import React, { useEffect, useState } from "react";
import "./NewsSection.css";

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(
          `https://newsdata.io/api/1/latest?apikey=${process.env.REACT_APP_NEWS_API_KEY}&language=en&q=cryptocurrency`
        );
        const data = await response.json();
        console.log("API Response:", data);

        // NewsData uses "results" key on some responses
        if (data && Array.isArray(data.results) && data.results.length > 0) {
          setNews(data.results);
        } else {
          console.error("No valid news results found.", data);
          setNews([]);
          setError("No news articles found.");
        }
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Failed to load news.");
      }
    };

    fetchNews();
  }, []);

  return (
    <section className="news-section" style={{ backgroundColor: 'black', color: 'white' }}>
      <h2 style={{ color: 'white' }}>Latest News & Stories</h2>
      <div className="news-cards">
        {error ? (
          <p style={{ textAlign: "center", color: "red" }}>{error}</p>
        ) : news.length > 0 ? (
          news.map((article, index) => (
            <div key={index} className="news-card" style={{ backgroundColor: '#1a1a1a', color: 'white' }}>
              <img
                src={
                  article.image_url ||
                  "https://source.unsplash.com/400x300/?technology"
                }
                alt={article.title}
              />
              <h3 style={{ color: 'white' }}>{article.title}</h3>
              <p style={{ color: '#cccccc' }}>{article.description || "No description available."}</p>
              <a 
                href={article.link} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: '#4fc3f7' }}
              >
                Read More →
              </a>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", color: 'white' }}>Loading news…</p>
        )}
      </div>
    </section>
  );
};

export default NewsSection;